import { createTelegramPlatform, isTelegramWebApp } from './telegram';
import type { Platform, PlatformKind } from './types';
import { createVkPlatform, isVkMiniApp } from './vk';
import { createWebPlatform } from './web';

export type {
  Platform,
  PlatformChrome,
  PlatformIdentity,
  PlatformKind,
  PlatformTheme,
  PlatformViewport,
  SharePayload,
} from './types';

export function detectPlatformKind(): PlatformKind {
  if (isTelegramWebApp()) {
    return 'telegram';
  }

  if (isVkMiniApp()) {
    return 'vk';
  }

  return 'web';
}

let instance: Platform | null = null;

/**
 * Единая точка входа в платформенный слой.
 *
 * Экземпляр создаётся один раз за время жизни вкладки: Telegram/VK-обвязки
 * держат подписки на события хоста, пересоздавать их при каждом вызове
 * незачем, а некоторые действия (VKWebAppInit) должны случиться единожды.
 */
export function getPlatform(): Platform {
  instance ??= createPlatform(detectPlatformKind());

  return instance;
}

function createPlatform(kind: PlatformKind): Platform {
  switch (kind) {
    case 'telegram':
      return createTelegramPlatform();
    case 'vk':
      return createVkPlatform();
    case 'web':
      return createWebPlatform();
  }
}

/** Только для тестов — сбрасывает синглтон между кейсами. */
export function __resetPlatformForTests(): void {
  instance = null;
}
